import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from './input-group';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            filteredOptions: null,
            text: null,
            error: null,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps != this.props) {
            return true;
        }

        if (nextState.filteredOptions != this.state.filteredOptions) {
            return true;
        }

        if (nextState.error != this.state.error) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <autocomplete-group
                ref={el => this.el = el}
                className={this.props.error || this.state.error ? 'has-error' : ''}
            >
                {this.renderError()}
                <InputGroup
                    placeholder={this.props.placeholder}
                    name={this.props.name}
                    label={this.props.label}
                    disabled={this.props.disabled}
                    value={this.props.text || this.state.text}
                    error={this.props.error || this.state.error}
                    onInput={this.filterOptions}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                />
                <input type='hidden' value={this.props.value} />
                {this.renderOptions()}
            </autocomplete-group>
        );
    }

    filterOptions = (e) => {
        let filteredOptions = [];
        let value = null;

        if (e.target.value) {
            const re = new RegExp(`^${e.target.value}`, 'i');

            filteredOptions = _.pick(this.props.options, (text) => {
                return text.match(re);
            });
        }

        this.setState({
            filteredOptions: filteredOptions,
            text: e.target.value,
        });

        if (Object.keys(filteredOptions).length == 1) {
            const key = Object.keys(filteredOptions)[0];

            if (e.target.value == filteredOptions[key]) {
                value = key;
                this.setState({ error: null });
            }
        }

        this.props.onSelect({
            type: 'change',
            target: {
                name: this.props.name,
                text: e.target.value,
                value: value,
            },
        });
    }

    renderOptions = () => {
        if (this.state.filteredOptions && Object.keys(this.state.filteredOptions).length) {
            return (
                <div className='autocomplete-group-list'>
                    {Object.keys(this.state.filteredOptions).map(value => {
                        return (
                            <a onClick={this.selectItem} data-value={value}>{this.state.filteredOptions[value]}</a>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    renderError = () => {
        if (this.state.error && this.state.filteredOptions && Object.keys(this.state.filteredOptions).length) {
            return (<p className='is-error'>{this.state.error}</p>);
        }

        return null;
    }

    selectItem = (e) => {
        this.props.onSelect({
            type: 'change',
            target: {
                name: this.props.name,
                text: e.target.innerHTML,
                value: e.target.dataset.value,
            },
        });

        this.setState({
            filteredOptions: null,
            text: null,
            error: null,
        });
    }

    onBlur = () => {
        if (!this.props.value) {
            this.setState({ error: 'Please choose an option from the list' });
        } else {
            const list = this.el.querySelector('.autocomplete-group-list');

            if (list) {
                setTimeout(() => { list.style.display = 'none'; }, 250);
            }
        }
    }

    onFocus = () => {
        const list = this.el.querySelector('.autocomplete-group-list');

        if (list) {
            list.style.display = 'flex';
        }
    }
}

export default connect()(Component);